(() => {
  'use strict';
  if (window.CornerCouponCheckout) return;
  const english = () => /^en(?:-|$)/i.test(document.documentElement.lang);
  const text = (ja, en) => english() ? en : ja;
  const root = () => /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(window.Shopify?.routes?.root || '') ? window.Shopify.routes.root : english() ? '/en/' : '/';
  const esc = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const prefix = 'corner-purchase-v1:';
  const ttl = 2 * 60 * 60 * 1000;
  let picker = null;
  const token = () => picker ? picker.id : new URLSearchParams(location.search).get('corner_purchase');
  // Only our native checkout and selected-item permalinks can be resumed.
  function destination(value) {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || url.hash || url.username || url.password) throw Error('destination');
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout$/.test(url.pathname)) {
      if (url.search) throw Error('checkout parameters');
    } else if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/[1-9]\d*:[1-9]\d*$/.test(url.pathname)) {
      if ([...url.searchParams.keys()].some(key => key !== 'properties') || url.searchParams.getAll('properties').length > 1 || (url.searchParams.has('properties') && !/^[A-Za-z0-9_-]{1,12000}$/.test(url.searchParams.get('properties')))) throw Error('product parameters');
    } else throw Error('destination');
    return url.pathname + url.search;
  }
  function intent(id = token()) {
    if (!id) return {status:'none'};
    try {
      if (!/^[a-f0-9-]{36}$/.test(id)) throw Error('token');
      const saved = JSON.parse(sessionStorage.getItem(prefix + id));
      if (!saved || Date.now() - saved.at < 0 || Date.now() - saved.at > ttl) throw Error('expired');
      return {status:'ready', destination:destination(saved.destination), couponExcluded:saved.couponExcluded===true};
    } catch { return {status:'invalid'}; }
  }
  function urls(id = token()) {
    const wallet = new URL(root() + 'pages/contact', location.origin);
    wallet.searchParams.set('view', 'corner-mypage');
    wallet.searchParams.set('corner_view', 'coupons');
    if (id && /^[a-f0-9-]{36}$/.test(id)) wallet.searchParams.set('corner_purchase', id);
    const login = new URL(wallet.href);
    login.searchParams.set('corner_login', 'oxi');
    return {wallet:wallet.href, login:login.href};
  }
  const member = () => document.querySelector('script[data-corner-checkout-member]')?.dataset.cornerCheckoutMember === 'true';
  function walletPage() {
    const page = new URL(location.href), expected = new URL(urls().wallet);
    return page.pathname === expected.pathname && page.searchParams.get('view') === 'corner-mypage' && page.searchParams.get('corner_view') === 'coupons';
  }
  // This is a short-lived explicit link choice, not LINE identity or a wallet
  // entitlement. The service and authenticated order history verify eligibility.
  const campaignSlug = 'line-web-5', campaignCode = '4KQGC064DHRT';
  const campaignStorage = 'corner-campaign-intent-v1', campaignTTL = 10 * 60 * 1000;
  let campaignReady = null, campaignGeneration = 0;
  function readCampaign() {
    try {
      const item = JSON.parse(sessionStorage.getItem(campaignStorage));
      if (!item || item.slug !== campaignSlug || !/^[a-f0-9-]{36}$/.test(item.nonce) || !Number.isFinite(item.at) || Date.now()-item.at < 0 || Date.now()-item.at >= campaignTTL || !/^(guest|[a-f0-9]{64})$/.test(item.owner)) throw Error('intent');
      return item;
    } catch {try {sessionStorage.removeItem(campaignStorage);} catch {}return null;}
  }
  function consumeCampaign() {campaignGeneration++;try {sessionStorage.removeItem(campaignStorage);} catch {}}
  async function campaignOwner(customerId) {
    if (!/^[1-9][0-9]{0,19}$/.test(String(customerId || ''))) return 'guest';
    const bytes = new TextEncoder().encode('corner-link-intent-v1\n'+location.origin+'\n'+customerId);
    const digest = await crypto.subtle.digest('SHA-256',bytes);
    return [...new Uint8Array(digest)].map(x=>x.toString(16).padStart(2,'0')).join('');
  }
  function campaignKey() {const item=readCampaign();return item ? item.slug+':'+item.nonce : '';}
  function initializeCampaign() {
    if (campaignReady) return campaignReady;
    const generation=campaignGeneration;
    campaignReady = (async () => {
      const url = new URL(location.href), hint = url.searchParams.getAll('corner_offer');
      // Remove the marker immediately so reload / Back cannot re-seed a consumed choice.
      if (hint.length) {url.searchParams.delete('corner_offer');history.replaceState(history.state,'',url.href);}
      let seed;try {seed=JSON.parse(document.querySelector('[data-corner-wallet-bootstrap]')?.textContent || 'null');} catch {}
      const owner = await campaignOwner(member() ? seed?.walletAuth?.customerId : null);
      if (generation!==campaignGeneration) return;
      if (member() && owner==='guest') {consumeCampaign();return;}
      if (hint.length===1 && hint[0]===campaignSlug) {
        const cookies=String(document.cookie||'').split(';').map(x=>x.trim()).filter(x=>x.startsWith('discount_code='));
        if (cookies.length!==1 || decodeURIComponent(cookies[0].slice('discount_code='.length)).toUpperCase()!==campaignCode) {consumeCampaign();return;}
        const item={slug:campaignSlug,at:Date.now(),nonce:crypto.randomUUID(),owner};
        sessionStorage.setItem(campaignStorage,JSON.stringify(item));
        return;
      }
      const item=readCampaign();
      if (!item || item.owner===owner) return;
      // Only our pending guest sign-in may transfer this tab's explicit link choice.
      if (item.owner==='guest' && owner!=='guest' && loginReturn()) sessionStorage.setItem(campaignStorage,JSON.stringify({...item,owner}));
      else consumeCampaign();
    })().catch(()=>{consumeCampaign();});
    return campaignReady;
  }
  async function campaignRequest(customerId) {
    await initializeCampaign();
    const item=readCampaign();if(!item)return null;
    const owner=await campaignOwner(customerId);
    if(owner==='guest'||owner!==item.owner){consumeCampaign();return null;}
    return {slug:item.slug,key:campaignKey(),expires:item.at+campaignTTL};
  }
  const loginKey = 'corner-coupon-login-v1';
  const loginTTL = 30 * 60 * 1000;
  function clearLoginReturn() {try {sessionStorage.removeItem(loginKey);} catch {}}
  function saveLoginReturn(wallet) {
    const saved = JSON.stringify({at:Date.now(), wallet});
    sessionStorage.setItem(loginKey, saved);
    if (sessionStorage.getItem(loginKey) !== saved) throw Error('storage');
  }
  function loginReturn() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(loginKey));
      if (!saved || Date.now()-saved.at < 0 || Date.now()-saved.at > loginTTL) return null;
      const url = new URL(saved.wallet, location.origin);
      if (url.origin !== location.origin || url.username || url.password || url.hash || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/contact$/.test(url.pathname)) return null;
      if (url.searchParams.get('view') !== 'corner-mypage' || url.searchParams.get('corner_view') !== 'coupons') return null;
      if ([...url.searchParams.keys()].some(key => !['view','corner_view','corner_purchase'].includes(key)) || [...url.searchParams.keys()].some(key => url.searchParams.getAll(key).length !== 1)) return null;
      if (url.searchParams.has('corner_purchase') && !/^[a-f0-9-]{36}$/.test(url.searchParams.get('corner_purchase'))) return null;
      return url.href;
    } catch { return null; }
  }
  let openingOxi, oxiAnchor;
  function loginAnchor() {
    if (oxiAnchor?.isConnected) return oxiAnchor;
    oxiAnchor = document.createElement('a');
    oxiAnchor.href = root() + 'account/login';
    oxiAnchor.hidden = true;
    oxiAnchor.tabIndex = -1;
    oxiAnchor.setAttribute('data-osl-external', 'true');
    oxiAnchor.setAttribute('aria-hidden', 'true');
    document.body.appendChild(oxiAnchor);
    return oxiAnchor;
  }
  function openOxi() {
    if (openingOxi) return openingOxi;
    // Reuse Oxi's bound account link on this page; no intermediate navigation.
    openingOxi = new Promise((resolve, reject) => {
      const anchor = loginAnchor(), started = Date.now();
      function ready() {
        if (anchor._osl_bound && document.getElementById('oxipopup_login')) {
          const click = new MouseEvent('click', {bubbles:true, cancelable:true});
          anchor.dispatchEvent(click);
          if (click.defaultPrevented) resolve(); else reject(Error('Oxi unavailable'));
        } else if (Date.now() - started >= 10000) reject(Error('Oxi unavailable'));
        else setTimeout(ready, 100);
      }
      ready();
    }).finally(() => {openingOxi = null;});
    return openingOxi;
  }
  function loginError() {
    const host = document.querySelector('.cmp-auth') || document.querySelector('[data-corner-coupon-entry]')?.parentElement || document.getElementById('MainContent');
    if (!host) return;
    let notice = host.querySelector('[data-corner-login-error]');
    if (!notice) {notice=document.createElement('p');notice.className='ccp-resume';notice.dataset.cornerLoginError='';notice.setAttribute('role','status');host.appendChild(notice);}
    notice.textContent = text('ログイン画面を読み込めませんでした。もう一度お試しください。','The sign-in window could not load. Please try again.');
  }
  async function signIn(id = token(), budget = 900, origin = null) {
    const next = urls(id);
    if (member()) {await openPicker(id,budget,origin);return true;}
    const selected = current || origin;
    try {
      // Only a fixed wallet route and purchase token are stored; never identity
      // or login credentials. Oxi returns here normally after authentication.
      saveLoginReturn(next.wallet);
      document.querySelector('[data-corner-login-error]')?.remove();
      close();
      await openOxi();
      return true;
    } catch {
      clearLoginReturn();
      if (selected) {
        offer(selected);
        dialog.querySelector('.ccp-error').textContent = text('ログイン画面を読み込めませんでした。もう一度お試しいただくか、そのまま購入手続きへお進みください。','The sign-in window could not load. Please try again or continue to checkout.');
      } else loginError();
      return false;
    }
  }
  // Explicit dismissal cancels this continuation, but changing Oxi's login /
  // registration panel does not. Successful authentication is only established
  // by Shopify's server-rendered customer marker on the returned page.
  document.addEventListener('click', event => {
    if (event.target.closest?.('a[href="#close-sl_modal"]') || event.target.classList?.contains('oxiblocker')) clearLoginReturn();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.querySelector('.oxiblocker.current')) clearLoginReturn();
  });
  window.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-corner-coupon-entry]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (new URL(link.href, location.origin).origin !== location.origin) return;
    event.preventDefault();event.stopImmediatePropagation();signIn();
  }, true);
  async function openRequestedLogin() {
    await initializeCampaign();
    const next = loginReturn();
    clearLoginReturn();
    if (member() && next) {
      openPicker(new URL(next).searchParams.get('corner_purchase'));
      return;
    }
    loginAnchor();
    // Preserve links/bookmarks created by the previous release without routing
    // new clicks through this page before showing the login window.
    if (!member() && walletPage() && new URLSearchParams(location.search).get('corner_login') === 'oxi') signIn();
  }
  async function openPicker(id,budget=900,origin=null) {
    const resumed = intent(id);
    if (member() && (origin?.couponExcluded || resumed.status==='ready' && resumed.couponExcluded)) {
      return continueExcluded(origin || {destination:resumed.destination, proceed:() => location.assign(resumed.destination)});
    }
    if (picker) return;
    // Wait for the previous dialog to release its focus and scroll lock.
    if (dialog?.open) await new Promise(resolve => {dialog.addEventListener('close', resolve, {once:true});close();});
    if (picker) return;
    const sheet = document.createElement('dialog'), focus = document.activeElement, overflow = document.documentElement.style.overflow;
    sheet.className = 'ccp-dialog ccp-picker';
    sheet.setAttribute('aria-labelledby', 'ccp-picker-title');
    sheet.innerHTML = `<div class="ccp-panel"><button class="ccp-close" type="button" aria-label="${text('閉じる','Close')}">×</button><h2 id="ccp-picker-title">${text('クーポン','Coupons')}</h2><div data-wallet class="ccp-picker-content" aria-live="polite"><p role="status">${text('クーポンを確認しています…','Checking your coupons…')}</p></div><a class="ccp-skip">${text('クーポンを使わずに購入手続きへ','Continue without a coupon')}</a></div>`;
    const state = {id, sheet, dismiss:() => sheet.close()};picker = state;
    const target = sheet.querySelector('[data-wallet]'), skip = sheet.querySelector('.ccp-skip'), purchase = intent(id);
    if (purchase.status === 'invalid') {skip.hidden=true;target.textContent=text('購入情報の有効期限が切れました。購入する商品をもう一度お選びください。','Your purchase selection has expired. Please select your purchase again.');}
    else skip.href = purchase.status === 'ready' ? purchase.destination : root() + 'checkout';
    const cleanup = () => {
      if (state.cleaned) return;
      state.cleaned = true;state.cancelled = true;
      if (noCoupon?.host === sheet) noCoupon.controller.abort();
      clearTimeout(revealTimer);
      window.CornerWallet?.cancelPurchase?.(target);
      sheet.remove();
      if (picker === state) picker = null;
      document.documentElement.style.overflow = overflow;
      focus?.focus({preventScroll:true});
    };
    sheet.addEventListener('close', cleanup, {once:true});
    sheet.addEventListener('cancel', event => {event.preventDefault();state.dismiss();});
    sheet.querySelector('.ccp-close').addEventListener('click', () => state.dismiss());
    sheet.addEventListener('click', event => {if(event.target===sheet)state.dismiss();});
    skip.addEventListener('click', event => {
      event.preventDefault();
      if (noCoupon || purchase.status === 'invalid') return;
      continueWithoutCoupon(sheet, skip, cleaned => {
        // Keep the original cart POST (including its checkout submitter), or
        // the PDP's selected-item callback, just like the zero-coupon path.
        const proceed = origin?.proceed;
        scrubForm(origin?.form, cleaned);
        state.dismiss();
        if (proceed) proceed(); else location.assign(purchase.status === 'ready' ? purchase.destination : root() + 'checkout');
      }, () => picker === state && sheet.open);
    });
    document.body.appendChild(sheet);
    // A warm verified wallet usually answers at once; wait briefly before
    // showing the sheet so a zero-coupon purchase never flashes an empty picker.
    const reveal = () => {clearTimeout(revealTimer);if (picker === state && sheet.isConnected && !sheet.open) {sheet.showModal();document.documentElement.style.overflow='hidden';}};
    const revealTimer = setTimeout(reveal, 150);
    state.dismiss = () => {state.cancelled=true;clearTimeout(revealTimer);if (sheet.open) sheet.close();cleanup();};
    if (purchase.status === 'invalid') {reveal();return;}
    const onResult = async result => {
        // Nothing usable for these items: do not show an empty coupon picker.
        // Reconcile inherited codes before continuing a real purchase.
        // A coupon whose status is unclear is not usable either (Yukie 2026-10-26).
        if (picker===state && !state.cancelled && !noCoupon && !couponChoices.has(sheet) && (origin || purchase.status==='ready') && result?.status==='verified' && result.availableCount===0) {
          // No wallet selection is available. Any current cart code still
          // requires the shopper's choice; its source cannot be inferred.
          await continueWithoutCoupon(sheet, skip, cleaned => {
            const proceed = origin?.proceed, form = origin?.form;
            scrubForm(form, cleaned);
            state.dismiss();
            if (proceed) proceed(); else location.assign(purchase.status === 'ready' ? purchase.destination : root() + 'checkout');
          }, () => picker === state && !state.cancelled, 'inherited', [], (result.rejectedCodes?.length || result.campaignRejected) ? signal=>rejectKnownCodes([...(result.rejectedCodes||[]),...(result.campaignRejected?[campaignCode]:[])],signal,result.firstBenefitStatus==='used') : null);
          if (picker === state) reveal();
          return;
        }
        if (picker===state && !state.cancelled) reveal();
    };
    const load = async () => {
      target.innerHTML=`<p role="status">${text('クーポンを確認しています…','Checking your coupons…')}</p>`;
      try {
        const started=Date.now();
        while (!window.CornerWallet?.loadPurchase) {
          if(picker!==state)return;
          if(Date.now()-started>=850)throw Error('wallet unavailable');
          await new Promise(resolve=>setTimeout(resolve,25));
        }
        if(picker===state) await window.CornerWallet.loadPurchase(target,Math.max(0,budget-(Date.now()-started)),false,onResult);

      } catch {
        if(picker!==state)return;
        reveal();
        target.innerHTML=`<p role="status">${text('クーポンを読み込めませんでした。','We could not load your coupons.')}</p><button type="button" class="ccp-retry">${text('再読み込み','Retry')}</button>`;
        target.querySelector('.ccp-retry').addEventListener('click',load,{once:true});
      }
    };
    await load();
  }

  function discountURL(code, fallback) {
    const purchase = intent();
    if (purchase.status === 'invalid') throw Error('purchase expired');
    const path = purchase.status === 'ready' ? purchase.destination : fallback;
    if (purchase.status === 'ready' && /\/cart\//.test(path)) {
      if (code.includes(',')) throw Error('unsupported code');
      const url = new URL(path, location.origin);
      url.searchParams.set('discount', code);
      return url;
    }
    const url = new URL(root() + 'discount/' + encodeURIComponent(code), location.origin);
    url.searchParams.set('redirect', path);
    return url;
  }
  // A browser's historical code list cannot identify the current source or
  // shopper's intent. Ask about applicable codes before continuing implicitly.
  const couponChoices = new WeakMap();
  const cartCodes = cart => (cart.discount_codes || []).map(item => String(item.code || '').trim()).filter(Boolean);
  const codeKey = codes => [...new Set(codes.map(code => code.toUpperCase()))].sort().join('\n');
  async function cartRequest(path, options, signal) {
    if (signal.aborted) throw Error('cancelled');
    try {
      const response = await beforeDeadline(fetch(root() + path, {...options, credentials:'same-origin', cache:'no-store', signal}), signal);
      if (!response.ok) {
        const error = Error('cart request');
        error.cartTransient = response.status === 408 || response.status === 429 || response.status >= 500 && response.status <= 599;
        error.retryAfter = response.headers?.get('Retry-After');
        throw error;
      }
      return await beforeDeadline(response.json(), signal);
    } catch (error) {
      // Fetch/body transport failures are retryable; aborts and invalid JSON are not.
      if (!signal.aborted && error?.name === 'TypeError') error.cartTransient = true;
      throw error;
    }
  }
  function cartRetryPause(error, signal) {
    if (signal.aborted || !error.cartTransient) return Promise.reject(error);
    let delay = 175;
    if (error.retryAfter != null) {
      const value = String(error.retryAfter).trim();
      const requested = /^\d+(?:\.\d+)?$/.test(value) ? Number(value) * 1000 : Date.parse(value) - Date.now();
      if (Number.isFinite(requested)) delay = Math.max(delay, requested);
    }
    // Do not retry earlier than the server allows, or spend the whole checkout
    // deadline waiting for a rate limit. The shopper can explicitly retry later.
    if (delay > 2000) return Promise.reject(error);
    return new Promise((resolve, reject) => {
      const abort = () => {clearTimeout(timer);signal.removeEventListener('abort', abort);reject(Error('cancelled'));};
      const timer = setTimeout(() => {signal.removeEventListener('abort', abort);resolve();}, delay);
      signal.addEventListener('abort', abort, {once:true});
      if (signal.aborted) abort();
    });
  }
  async function readCart(signal) {
    for (let attempt = 0; attempt < 2; attempt++) {
      try {return await cartRequest('cart.js', {headers:{Accept:'application/json'}}, signal);}
      catch (error) {if (attempt) throw error;await cartRetryPause(error, signal);}
    }
  }
  function assertDiscountReadback(cart, keep, clearAll) {
    if (!Number.isInteger(cart.item_count) || cart.item_count < 0 || (cart.discount_codes != null && !Array.isArray(cart.discount_codes))) throw Error('cart response');
    if ((cart.discount_codes || []).some(item => typeof item.applicable !== 'boolean')) throw Error('coupon status unknown');
    const mismatch = () => {const error = Error('discount changed');error.cartMismatch = true;throw error;};
    if (codeKey(cartCodes(cart)) !== codeKey(keep) || (cart.discount_codes || []).some(item => item.applicable !== true)) mismatch();
    if (clearAll) {
      const applications = [...(cart.cart_level_discount_applications || []),
        ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
      if (applications.some(application => application?.type === 'discount_code')) mismatch();
    }
  }
  async function updateDiscount(keep, signal, retryClear) {
    for (let attempt = 0; attempt < (retryClear ? 2 : 1); attempt++) {
      try {
        const updated = await cartRequest('cart/update.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({discount:keep.join(',')})}, signal);
        if (!Number.isInteger(updated.item_count) || updated.item_count < 0) throw Error('cart response');
      } catch (error) {
        if (!error.cartTransient) throw error;
        await cartRetryPause(error, signal);
        // A lost POST response may still have cleared the code. Reconcile first;
        // only an explicit clear-all may repeat a write, at most once.
        const readback = await readCart(signal);
        try {assertDiscountReadback(readback, keep, retryClear);return readback;}
        catch (readError) {if (!readError.cartMismatch || !retryClear || attempt) throw readError;}
        continue;
      }
      return readCart(signal);
    }
  }
  // A first benefit re-issued after an unpaid cancelled order (CODE-R<order>).
  const reissuedFirstBenefit = code => /^(?:WELCOME5|4KQGC064DHRT)-R\d+$/.test(code);
  async function rejectKnownCodes(codesToReject, signal, wholeGroup = false) {
    // Only called after complete authenticated history / fresh rules establish
    // that these known first-benefit codes cannot be used for this purchase.
    // wholeGroup: a paid order used the shared first benefit, so every re-issue is used up too.
    const rejected=[...new Set(codesToReject.map(code=>String(code).trim().toUpperCase()))];
    if(!rejected.length || rejected.some(code=>![campaignCode,'WELCOME5'].includes(code)&&!reissuedFirstBenefit(code)))throw Error('rejected codes');
    const isRejected=code=>{const value=String(code).trim().toUpperCase();return rejected.includes(value)||wholeGroup&&reissuedFirstBenefit(value);};
    const headers={'Content-Type':'application/json',Accept:'application/json'};
    const cart=await readCart(signal);
    if(!Number.isInteger(cart.item_count)||!Array.isArray(cart.discount_codes))throw Error('cart');
    const codes=cartCodes(cart),keep=codes.filter(code=>!isRejected(code));
    if(keep.length!==codes.length){
      const update=await beforeDeadline(fetch(root()+'cart/update.js',{method:'POST',credentials:'same-origin',cache:'no-store',signal,headers,body:JSON.stringify({discount:keep.join(',')})}),signal);
      if(signal.aborted||!update.ok)throw Error('cart');
      const readback=await readCart(signal);
      if(!Array.isArray(readback.discount_codes)||codeKey(cartCodes(readback))!==codeKey(keep))throw Error('cart');
    }
    if(signal.aborted)throw Error('cancelled');
    const current=String(document.cookie||'').split(';').map(x=>x.trim()).filter(x=>x.startsWith('discount_code='));
    if(current.some(x=>isRejected(decodeURIComponent(x.slice('discount_code='.length))))){
      if(current.length!==1)throw Error('ambiguous cookie');
      document.cookie='discount_code=; Max-Age=0; Path=/';
      if(String(document.cookie||'').split(';').some(x=>x.trim().startsWith('discount_code=')))throw Error('discount cookie');
    }
    return {rejectedCodes:[...new Set([...rejected,...codes.filter(isRejected).map(code=>code.toUpperCase())])],wholeGroup};
  }
  function clearSavedDiscountCookie() {
    const present = () => /(?:^|;\s*)discount_code=/.test(document.cookie);
    if (!present()) return;
    // Expiration must match the original cookie's domain and path. A host-only
    // root deletion cannot remove cookies created by domain-scoped share links.
    const url = new URL(location.href), paths = new Set(['/']);
    const parts = url.pathname.split('/');
    for (let i = 1; i <= parts.length; i++) {
      const path = parts.slice(0, i).join('/') || '/';
      paths.add(path);paths.add(path.endsWith('/') ? path : path + '/');
    }
    const domains = [''];
    const labels = url.hostname.split('.');
    for (let i = 0; i < labels.length - 1; i++) {
      const domain = labels.slice(i).join('.');
      domains.push('; Domain=' + domain, '; Domain=.' + domain);
    }
    for (const path of paths) for (const domain of domains) {
      document.cookie = 'discount_code=; Max-Age=0; Path=' + path + domain;
      if (!present()) return;
    }
    throw Error('saved discount remains');
  }
  async function prepareCart(mode, signal, expected = []) {
    let keep = [], removed = [];
    if (mode !== 'all') {
      const cart = await readCart(signal);
      if (!Number.isInteger(cart.item_count) || cart.item_count < 0 || (cart.discount_codes != null && !Array.isArray(cart.discount_codes))) throw Error('cart response');
      for (const item of cart.discount_codes || []) {
        const code = String(item.code || '').trim();
        if (!code) continue;
        if (typeof item.applicable !== 'boolean') throw Error('coupon status unknown');
        if (item.applicable) keep.push(code); else removed.push(code);
      }
      if ((mode === 'inherited' && keep.length) || (mode === 'keep' && codeKey(keep) !== codeKey(expected))) {
        return {mode, keep, removed, needsChoice:true, changed:mode === 'keep'};
      }
      if (!removed.length) return {mode, keep, removed};
    }
    const cart = await updateDiscount(keep, signal, mode === 'all');
    assertDiscountReadback(cart, keep, mode === 'all');
    if (mode === 'all') {
      if (signal.aborted) throw Error('cancelled');
      clearSavedDiscountCookie();
      // Retire the previous best-effort history after an explicit opt-out.
      try {localStorage.removeItem('corner-wallet-applied-v1');} catch {}
    }
    return {mode, keep, removed};
  }
  function showCouponChoice(host, proceed, active, result) {
    couponChoices.get(host)?.restore();
    const panel = host.querySelector('.ccp-panel'), title = panel.querySelector('h2');
    const titleText = title?.textContent;
    const hidden = [...panel.children].filter(node => node !== title && !node.classList.contains('ccp-close')).map(node => [node, node.style.display]);
    hidden.forEach(([node]) => node.style.display = 'none');
    if (title) title.textContent = text('クーポンの確認','Confirm coupon');
    const container = document.createElement('div');
    container.className = 'ccp-picker-content';
    container.setAttribute('data-corner-current-discount', '');
    const explanation = result.changed
      ? text('カートのクーポンが変更されました。ご利用になるか、もう一度お選びください。','Your cart coupons changed. Please choose again.')
      : text('カートに適用中のクーポンがございます。今回のご購入でご利用になりますか。',result.keep.length > 1 ? 'Coupons are applied to your cart. Would you like to use them for this purchase?' : 'A coupon is applied to your cart. Would you like to use it for this purchase?');
    container.innerHTML = `<p>${explanation}</p>${result.keep.length ? `<p data-current-coupon-codes></p><button type="button" class="ccp-use" data-current-coupon-keep>${text('適用中のクーポンを使う',result.keep.length > 1 ? 'Use these coupons' : 'Use this coupon')}</button>` : `<p>${text('現在ご利用いただけるクーポンはございません。','No coupon is currently available.')}</p>`}<button type="button" class="ccp-direct" data-current-coupon-clear>${text('クーポンを使わずに購入','Continue without a coupon')}</button><p class="ccp-error" data-corner-skip-error role="status"></p>`;
    const codes = container.querySelector('[data-current-coupon-codes]');
    if (codes) {
      codes.textContent = result.keep.join(' / ');
      codes.setAttribute('aria-label', text('適用中のクーポンコード','Applied coupon codes'));
      codes.style.overflowWrap = 'anywhere';
    }
    panel.appendChild(container);
    let restored = false;
    const restore = () => {
      if (restored) return;
      restored = true;container.remove();
      hidden.forEach(([node, display]) => node.style.display = display);
      if (title) title.textContent = titleText;
      host.removeEventListener('close', restore);
      couponChoices.delete(host);
    };
    couponChoices.set(host, {container, restore});
    host.addEventListener('close', restore, {once:true});
    container.querySelector('[data-current-coupon-keep]')?.addEventListener('click', event => {
      continueWithoutCoupon(host, event.currentTarget, proceed, active, 'keep', result.keep, result.prepare);
    });
    container.querySelector('[data-current-coupon-clear]').addEventListener('click', event => {
      continueWithoutCoupon(host, event.currentTarget, proceed, active, 'all', [], result.prepare);
    });
    if (!host.open) {host.showModal();document.documentElement.style.overflow = 'hidden';}
    container.querySelector('button')?.focus({preventScroll:true});
  }
  // A cart form field must not resubmit a removed code; a code the customer
  // has just typed (not yet on the cart) is left alone in inherited mode.
  function scrubForm(form, result) {
    if (!form) return;
    const removed = result.removed.map(code => code.toUpperCase());
    [...form.elements].filter(field => field.name === 'discount').forEach(field => {
      if (result.mode === 'keep' || (result.mode === 'guest' && !field.value.trim())) field.value = result.keep.join(',');
      else if (result.mode === 'all') field.value = '';
      // A field may hold several codes; drop only the removed ones.
      else field.value = field.value.split(',').filter(code => {const value = code.trim().toUpperCase();return value && !removed.includes(value) && !(result.wholeGroup && reissuedFirstBenefit(value));}).map(code => code.trim()).join(',');
    });
  }
  // Signing out does not remove the discount stored on Shopify's cart.
  // Every explicit no-coupon choice must clear it before handing off.
  let noCoupon = null;
  async function continueWithoutCoupon(host, trigger, proceed, active = () => host.isConnected, mode = 'all', extra = [], prepare = null) {
    if (noCoupon) return;
    const controller = new AbortController(), operation = {controller, host};
    noCoupon = operation;
    const label = trigger.textContent;
    const controls = [...host.querySelectorAll('button:not(.ccp-close)')].map(button => [button, button.disabled]);
    const content = host.querySelector('.ccp-picker-content');
    const wasInert = content?.inert;
    if (content) content.inert = true;
    controls.forEach(([button]) => button.disabled = true);
    trigger.setAttribute('aria-busy', 'true');
    trigger.setAttribute('aria-disabled', 'true');
    trigger.textContent = text('購入手続きへ進みます…','Opening checkout…');
    const messageHost = couponChoices.get(host)?.container || host;
    let message = messageHost.querySelector('[data-corner-skip-error]');
    if (!message) {
      message = document.createElement('p');
      message.className = 'ccp-error';
      message.setAttribute('data-corner-skip-error', '');
      message.setAttribute('role', 'status');
      trigger.insertAdjacentElement('afterend', message);
    }
    message.textContent = '';
    const abort = () => controller.abort();
    host.addEventListener('close', abort, {once:true});
    window.addEventListener('pagehide', abort, {once:true});
    const timer = setTimeout(abort, 10000);
    try {
      const prepared = prepare ? await beforeDeadline(prepare(controller.signal), controller.signal) : null;
      const result = await prepareCart(mode, controller.signal, extra);
      // Keep a previously rejected code out of the original native form too.
      if (prepared?.rejectedCodes) {result.removed = [...new Set([...result.removed,...prepared.rejectedCodes])];result.wholeGroup = prepared.wholeGroup === true;}
      if (controller.signal.aborted || noCoupon !== operation || !active()) return;
      // The shopper's next choice re-reads the cart; known used-up codes stay rejected.
      if (result.needsChoice) {result.prepare = prepare;showCouponChoice(host, proceed, active, result);return;}
      clearLoginReturn();
      if (mode==='keep' || (mode==='all' && !current?.couponExcluded)) consumeCampaign();
      proceed(result);
    } catch {
      if (noCoupon === operation && active()) {
        message.textContent = text('購入手続きの準備ができませんでした。もう一度お試しください。','We could not prepare checkout. Please try again.');
        if (!host.open && typeof host.showModal === 'function') {host.showModal();document.documentElement.style.overflow = 'hidden';}
      }
    } finally {
      clearTimeout(timer);
      host.removeEventListener('close', abort);
      window.removeEventListener('pagehide', abort);
      controls.forEach(([button, disabled]) => button.disabled = disabled);
      if (content) content.inert = wasInert;
      trigger.removeAttribute('aria-busy');trigger.removeAttribute('aria-disabled');trigger.textContent = label;
      if (noCoupon === operation) noCoupon = null;
    }
  }
  // Capture clicks so a coupon cannot be reapplied while its removal is pending.
  document.addEventListener('click', event => {
    if (noCoupon && event.target.closest?.('[data-wallet-use],.ccp-use,.ccp-direct,.ccp-skip,[data-corner-purchase-continue]')) {
      event.preventDefault();event.stopImmediatePropagation();return;
    }
    const link = event.target.closest?.('[data-corner-purchase-continue]');
    if (!link) return;
    event.preventDefault();event.stopImmediatePropagation();
    const purchase = intent();
    if (purchase.status !== 'ready') return;
    const host = link.closest('.ccp-resume');
    if (!host) return;
    continueWithoutCoupon(host, link, () => location.assign(purchase.destination));
  }, true);
  function resumeHTML() {
    const purchase = intent();
    if (purchase.status === 'none') return '';
    if (purchase.status === 'invalid') return `<p class="ccp-resume" role="status">${text('購入情報の有効期限が切れました。購入する商品をもう一度お選びください。','Your purchase selection has expired. Please select your purchase again.')}</p>`;
    return `<div class="ccp-resume"><span>${text('クーポンを選ぶと、購入手続きへ進みます。','Choose a coupon to continue to checkout.')}</span><a data-corner-purchase-continue href="${esc(purchase.destination)}">${text('選ばずに購入手続きへ','Continue without selecting a coupon')}</a></div>`;
  }
  let dialog, current, lastFocus, savedOverflow, busy = false;
  function close() {current = null;if (noCoupon?.host === dialog) noCoupon.controller.abort();if (!dialog?.open) return;dialog.close();}
  function buildDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'ccp-dialog';
    dialog.setAttribute('aria-labelledby', 'ccp-heading');
    dialog.innerHTML = `<div class="ccp-panel"><button class="ccp-close" type="button" aria-label="${text('閉じる','Close')}">×</button><h2 id="ccp-heading"></h2><p class="ccp-lead"></p><button type="button" class="ccp-use"></button><button type="button" class="ccp-direct"></button><p class="ccp-note"></p><p class="ccp-error" role="status" aria-live="polite"></p></div>`;
    document.body.appendChild(dialog);
    dialog.querySelector('.ccp-close').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('cancel', event => {event.preventDefault();close();});
    dialog.addEventListener('close', () => {document.documentElement.style.overflow = savedOverflow;current = null;lastFocus?.focus({preventScroll:true});});
    dialog.querySelector('.ccp-direct').addEventListener('click', event => continueDialog(event.currentTarget));
    dialog.querySelector('.ccp-use').addEventListener('click', async () => {
      if (busy || !current) return;
      busy = true;
      dialog.querySelectorAll('button').forEach(button => button.disabled = true);
      const message = dialog.querySelector('.ccp-error');message.textContent = '';
      try {
        const selected = current;
        await startCoupon(selected, () => current === selected);
      } catch { message.textContent = text('クーポンの画面を開けませんでした。もう一度お試しいただくか、そのまま購入手続きへお進みください。','We could not open your coupons. Please try again or continue to checkout.'); }
      finally { busy = false;dialog.querySelectorAll('button').forEach(button => button.disabled = false); }
    });
  }
  function continueDialog(trigger) {
    if (busy || !current) return;
    const selected = current;
    // Guests go straight to checkout: applicable cart codes stay, without a confirmation step.
    continueWithoutCoupon(dialog, trigger, result => {
      scrubForm(selected.form, result);
      close();current = null;selected.proceed();
    }, () => current === selected, member() || selected.couponExcluded ? 'all' : 'guest', [], selected.prepare);
  }
  // These products cannot use coupon codes. Clear codes without inviting a
  // selection, verify the cart, then continue the original purchase.
  function continueExcluded(options) {
    // Coupon exclusion must never bypass the guest sign-in choice.
    if (!member()) return offer({...options, couponExcluded:true, scopeChecked:true});
    buildDialog();
    if (dialog.open || picker || noCoupon || current) return true;
    current = {...options, couponExcluded:true};
    lastFocus = document.activeElement;savedOverflow = document.documentElement.style.overflow;
    dialog.querySelector('#ccp-heading').textContent = text('ご購入手続き','Checkout');
    dialog.querySelector('.ccp-lead').textContent = '';
    dialog.querySelector('.ccp-use').style.display = 'none';
    dialog.querySelector('.ccp-direct').textContent = text('もう一度試す','Try again');
    dialog.querySelector('.ccp-note').hidden = true;
    dialog.querySelectorAll('.ccp-error').forEach(message => message.textContent = '');
    continueDialog(dialog.querySelector('.ccp-direct'));
    return true;
  }
  // Save only the purchase context, then sign in (guest) or open the picker (member).
  let starting = null;
  async function startCoupon(selected, active = () => true) {
    if (starting) return starting;
    const started=Date.now(), controller = new AbortController(), timer = setTimeout(() => controller.abort(), 900);
    starting = (async () => {
      const id = crypto.randomUUID(), saved = {at:Date.now(), destination:destination(selected.destination), couponExcluded:selected.couponExcluded===true};
      // Purchase context only; never store identity, authentication or coupon codes.
      for (let i = sessionStorage.length - 1; i >= 0; i--) {const key = sessionStorage.key(i);if(key?.startsWith(prefix)){try{if(Date.now()-JSON.parse(sessionStorage.getItem(key)).at>ttl)sessionStorage.removeItem(key);}catch{sessionStorage.removeItem(key);}}}
      sessionStorage.setItem(prefix + id, JSON.stringify(saved));
      if (sessionStorage.getItem(prefix + id) !== JSON.stringify(saved)) throw Error('storage');
      if (selected.prepare) await beforeDeadline(selected.prepare(controller.signal),controller.signal);
      if (!active() || controller.signal.aborted) throw Error('cancelled');
      clearTimeout(timer);
      await signIn(id,Math.max(0,900-(Date.now()-started)), selected);
    })().finally(() => {clearTimeout(timer);starting = null;});
    return starting;
  }
  function productScope(path) {
    const match = new URL(path, location.origin).pathname.match(/\/cart\/(\d+):\d+$/);
    if (!match) return null;
    try {
      const data=JSON.parse(document.querySelector('[data-corner-coupon-product]')?.textContent||'null');
      if (!data || !data.variants.some(id=>String(id)===match[1]) || !Array.isArray(data.collections)) return null;
      return data.collections;
    } catch {return null;}
  }
  function applicable(coupon,seed) {
    const purchase=intent();
    if(purchase.status==='invalid')return false;
    if(purchase.status==='none')return true;
    const scope=productScope(purchase.destination);
    if(scope===null&&/\/cart\//.test(purchase.destination))return false;
    const collections=scope||seed?.cartItems?.flatMap(item=>item.quantity>0?item.collections:[])||[];
    if(!collections.length)return false;
    return (coupon.collections||[]).some(collection=>collections.includes(collection.handle)) || (coupon.conditions||[]).includes('全商品対象');
  }
  let checkingCart = false;
  function cartScope(form){
    if(!form)return null;
    const fields=[...form.querySelectorAll('input[name="updates[]"]')];
    if(!fields.length)return null;
    try{return fields.map(input=>{
      const collections=JSON.parse(input.getAttribute('data-corner-coupon-scopes'));
      const quantity=Number(input.value);
      if(!Array.isArray(collections)||!Number.isInteger(quantity)||quantity<0)throw Error('scope');
      return {quantity,collections};
    });}catch{return null;}
  }
  function beforeDeadline(task,signal){return new Promise((resolve,reject)=>{const abort=()=>reject(Error('timeout'));if(signal.aborted){abort();return;}signal.addEventListener('abort',abort,{once:true});Promise.resolve(task).then(resolve,reject).finally(()=>signal.removeEventListener('abort',abort));});}
  async function checkCartOffer(options) {
    if(checkingCart)return;
    checkingCart=true;
    const button=document.activeElement, controller=new AbortController(),timer=setTimeout(()=>controller.abort(),900);
    button?.setAttribute('aria-busy','true');
    const restore=()=>{clearTimeout(timer);checkingCart=false;button?.removeAttribute('aria-busy');};
    try {
      if(options.prepare)await beforeDeadline(options.prepare(controller.signal),controller.signal);
      if(!window.CornerWallet?.context)throw Error('wallet unavailable');
      const data=await beforeDeadline(window.CornerWallet.context(1,controller.signal),controller.signal);
      if(controller.signal.aborted)throw Error('timeout');
      if(!Array.isArray(data.cartItems))throw Error('cart unavailable');
      window.CornerWallet.adopt(data);
      restore();
      const items=data.cartItems.filter(item=>item.quantity>0);
      if(items.length && items.every(item=>Array.isArray(item.collections)&&item.collections.length===0))continueExcluded({...options,prepare:null});
      else offer({...options,scopeChecked:true,prepare:null});
    } catch {
      restore();
      offer({...options,scopeChecked:true});
      dialog.querySelector('.ccp-error').textContent=text('クーポンを確認できませんでした。もう一度お試しいただくか、そのまま購入手続きへお進みください。','We could not check your coupons. Please try again or continue to checkout.');
    }
  }

  function offer(options) {
    if (!window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') return false;
    try { destination(options.destination); } catch { return false; }
    if (!options.couponExcluded) {
    const scope = productScope(options.destination);
    if (scope && !scope.length) return continueExcluded(options);
    if (scope === null && /\/cart\//.test(options.destination)) return false;
    const cartItems=cartScope(options.form);
    if(scope===null&&cartItems?.some(item=>item.quantity>0)&&!cartItems.some(item=>item.quantity>0&&item.collections.length))return continueExcluded(options);
    if (scope === null && !cartItems && !options.scopeChecked) {checkCartOffer(options);return true;}
    }
    buildDialog();
    if (dialog.open || picker || noCoupon || current) return true;
    if (member() && !options.memberFallback) {
      if (starting) return true;
      startCoupon(options).catch(() => offer({...options, memberFallback:true, scopeChecked:true}));
      return true;
    }
    current = options;lastFocus = document.activeElement;savedOverflow = document.documentElement.style.overflow;
    dialog.querySelectorAll('.ccp-error').forEach(message => message.textContent = '');
    const copy = member() ? {
      heading:text('ご購入手続き','Checkout'), lead:text('ご利用いただけるクーポンをお選びいただけます。','You can choose a coupon available for this purchase.'),
      use:text('クーポンを選ぶ','Choose a coupon'), direct:text('クーポンを使わずに購入','Continue without a coupon'), note:''
    } : {
      heading:text('ログインのご案内','Sign in'), lead:options.couponExcluded ? text('ログインまたは新規会員登録をして、ご購入手続きをお進めいただけます。今回の商品はクーポン対象外です。','You can sign in or create an account before continuing. These items are not eligible for coupons.') : text('ログインまたは新規会員登録をしていただくと、今回の商品にご利用いただける会員クーポンをお選びいただけます。','Sign in or create an account to choose from member coupons available for these items.'),
      use:text('ログイン・新規登録','Sign in / Create account'), direct:text('ログインせずに購入','Continue as guest'), note:text('会員登録をされなくても、そのままご購入いただけます。','You can also check out without an account.')
    };
    dialog.querySelector('#ccp-heading').textContent = copy.heading;
    dialog.querySelector('.ccp-lead').textContent = copy.lead;
    dialog.querySelector('.ccp-use').style.display = '';
    dialog.querySelector('.ccp-use').textContent = copy.use;
    dialog.querySelector('.ccp-direct').textContent = copy.direct;
    dialog.querySelector('.ccp-note').textContent = copy.note;
    dialog.querySelector('.ccp-note').hidden = !copy.note;
    dialog.showModal();document.documentElement.style.overflow = 'hidden';
    if (options.memberFallback) dialog.querySelector('.ccp-error').textContent = text('クーポンを確認できませんでした。もう一度お試しいただくか、そのまま購入手続きへお進みください。','We could not check your coupons. Please try again or continue to checkout.');
    return true;
  }
  const bypass = new WeakSet();
  document.addEventListener('submit', event => {
    const form = event.target, button = event.submitter;
    if (event.defaultPrevented || bypass.has(form) || button?.name !== 'checkout' || button.disabled) return;
    const action = new URL(form.action, location.origin);
    if (action.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/.test(action.pathname)) return;
    const proceed = () => {bypass.add(form);try{form.requestSubmit(button);}finally{bypass.delete(form);}};
    const prepare = async signal => {
      const editable=[...form.querySelectorAll('input,textarea')].filter(e=>e.name==='note'||e.name==='updates[]'||/^(attributes|updates)\[.+\]$/.test(e.name));
      if(editable.every(e=>e.value===e.defaultValue))return;
      const source = new FormData(form), body = new FormData();
      for (const [key, value] of source) if (key === 'note' || key === 'updates[]' || /^(attributes|updates)\[.+\]$/.test(key)) body.append(key,value);
      if (![...body.keys()].length) return;
      const response = await fetch(root() + 'cart/update.js', {method:'POST',body,credentials:'same-origin',headers:{Accept:'application/json'},signal});
      if (!response.ok) throw Error('cart');
      const result = await response.json();if (!Number.isInteger(result.item_count) || result.item_count < 1) throw Error('empty');
    };
    if (offer({destination:root() + 'checkout', proceed, prepare, form})) event.preventDefault();
  });
  window.addEventListener('pageshow', event => {if(event.persisted){if(dialog?.open)close();if(picker)picker.dismiss();busy=false;}});
  window.CornerCouponCheckout = {version:'guest-direct-checkout-20261029b',offer, intent, urls, discountURL, resumeHTML, signIn, applicable, campaignRequest, campaignKey, consumeCampaign, campaignReady:initializeCampaign};
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', openRequestedLogin, {once:true}); else openRequestedLogin();
})();
